module.exports = __webpack_public_path__ + "img/dynamic-22.4ff62f5b.png";